import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { CreatedUser, User } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface PostUserParams extends DefaultHttpHeaders {}

@Injectable()
export class PostUserService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }
  /**
   * Save user
   * Save user
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/postUser
   */
  postUser(body: User, params: PostUserParams): Observable<CreatedUser> {
    return this.post<CreatedUser, User>({
      suffix: '/comeround/applicationUtilities/user',
      body,
    });
  }
}
